import Sidebar from "Components/Sidebar/Sidebar";
import Navbar from "Components/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import LoadingBanner from "Components/shared/LoadingBanner";
import { useEffect, useState } from "react";

const MainLayout = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1);
  }, []);

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/*act like main body  */}
      <LoadingBanner isLoading={isLoading} />
      <div>
        <Sidebar />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Navbar />
        <div style={{ flex: 1, overflow: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
